import DashboardLayout from "@/layouts/DashboardLayout";
import * as g from '@/apps/auth/router/guards';

export default {
  path: "/settings",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "UserSettings",
      component: () => import("@/apps/user/components/UserSettingsPage"),
      props: true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: "Настройки" }
    },
    {
      path: "/settings/set",
      name: "SetAddress",
      component: () => import("@/apps/user/components/SelectAddressPage"),
      props: true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: "Настройки адреса" }
    }
  ]
};
